import { Alert, Box, Card, CardContent, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

export function accessEnabled(access, now = Date.now()) {
  return !!access?.enabled && (!access.expiresAt || new Date(access.expiresAt).getTime() > now);
}

export default function AdminAnalytics({ users, catalog, pendingPayments = [] }) {
  const rows = Object.entries(catalog).map(([app, tool]) => ({ app, title: tool.title,
    enabled: users.filter(user => accessEnabled(user.appsAccess?.[app])).length,
  }));
  const withAccess = users.filter(user => Object.values(user.appsAccess || {}).some(a => accessEnabled(a))).length;
  return <Box mb={3}>
    <Alert severity="info" sx={{ mb: 2 }}>Estos datos muestran permisos de acceso. El uso efectivo se consulta en Uso real. Los ingresos y la conversión a Pro requieren pagos confirmados; no se calculan desde permisos.</Alert>
    <Grid container spacing={2} mb={2}>
      {[[users.length, 'Usuarios registrados'], [withAccess, 'Con accesos habilitados'], [pendingPayments.length, 'Pagos pendientes de revisión']].map(([value, label]) => <Grid item xs={12} sm={4} key={label}><Card variant="outlined"><CardContent><Typography variant="h4">{value}</Typography><Typography>{label}</Typography></CardContent></Card></Grid>)}
    </Grid>
    <Typography variant="h6">Accesos habilitados por herramienta</Typography>
    <Table size="small"><TableHead><TableRow><TableCell>Herramienta</TableCell><TableCell>Usuarios con permiso vigente</TableCell></TableRow></TableHead><TableBody>{rows.map(row => <TableRow key={row.app}><TableCell>{row.title}</TableCell><TableCell>{row.enabled}</TableCell></TableRow>)}</TableBody></Table>
  </Box>;
}
